import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchPurchaseTicketsByUserId,
  fetchAllPurchaseTicketsByUserId,
} from "../../utilities/services/tickets";

// Async thunk to fetch purchase tickets by user ID
export const getPurchaseTickets = createAsyncThunk(
  "purchaseTicket/getPurchaseTickets",
  async (userId) => {
    const response = await fetchPurchaseTicketsByUserId(userId);
    return response.data;
  }
);

// Async thunk to fetch all purchase tickets
export const getAllPurchaseTickets = createAsyncThunk(
  "purchaseTicket/getAllPurchaseTickets",
  async (userId, dateRange, start_date, end_date) => {
    const response = await fetchAllPurchaseTicketsByUserId(
      userId,
      dateRange,
      start_date,
      end_date
    );
    return response.data;
  }
);

const purchaseTicketsSlice = createSlice({
  name: "purchaseTicket",
  initialState: {
    purchaseTicket: [],
    allPurchaseTickets: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearTickets: (state) => {
      state.purchaseTicket = [];
      state.allPurchaseTickets = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle getPurchaseTickets
      .addCase(getPurchaseTickets.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPurchaseTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.purchaseTicket = action.payload;
      })
      .addCase(getPurchaseTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Handle getAllPurchaseTickets
      .addCase(getAllPurchaseTickets.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllPurchaseTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.allPurchaseTickets = action.payload;
      })
      .addCase(getAllPurchaseTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearTickets } = purchaseTicketsSlice.actions;
export default purchaseTicketsSlice.reducer;
